import React from 'react';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { editPublicacion } from '../../../../actions/publicacionesActions';
import PropTypes from 'prop-types';

class DescripcionAmpliada extends React.Component {
    constructor(props) {
        super(props);
        this.editorRef = React.createRef(); // Crea la referencia para el editor
    }

    handleEditorChange = (content) => {
        const publicacion = { ...this.props.publicacion };

        // Verifica si el contenido es equivalente a un párrafo vacío
        if (content === '<p><br></p>') {
            publicacion["descripcionAmpliada"] = '';
        } else {
            publicacion["descripcionAmpliada"] = content;
        }

        this.props.editPublicacion(publicacion);
    };

    handleContainerClick = () => {
        if (this.editorRef.current) {
            const quillEditor = this.editorRef.current.getEditor();
            const selection = quillEditor.getSelection();

            if (!selection || selection.index === null) {
                // Si no hay selección (clic en área vacía), mueve el cursor al final
                const contentLength = quillEditor.getLength();
                quillEditor.focus(); // Enfoca el editor
                quillEditor.setSelection(contentLength - 1, 0); // Posiciona al final del contenido
            }
            
        }
    };

    render() {
        return (
            <ReactQuill
                ref={this.editorRef}
                theme="snow"
                modules={DescripcionAmpliada.modules}
                value={this.props.publicacion.descripcionAmpliada}
                onChange={this.handleEditorChange}
                onFocus={this.handleContainerClick}
            />
        );
    }
}

DescripcionAmpliada.modules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }], // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }], // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent
        [{ 'direction': 'rtl' }], // text direction
        [{ 'size': ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['clean']
    ]
};
DescripcionAmpliada.propTypes = {
    // Redux props
    publicacion: PropTypes.shape({
        descripcionAmpliada: PropTypes.string
    }),
    // Actions props
    editPublicacion: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    publicacion: state.publicaciones.publicacion,
    tipoUsuario: state.general.tipoUsuario
});

export default connect(mapStateToProps, { editPublicacion })(DescripcionAmpliada);
